import {PageDescription} from './page-description';
import {CCRoles} from '../../model/security/cc-roles-type';
import {AsbCCUrl} from './abs-cc-url';

export class CrystalClearFrontUrlExchange extends AsbCCUrl {
  // EXCHANGE
  static readonly EXCHANGE: PageDescription = {
    label: 'page_title.exchange.title',
    roles: CCRoles.ROLES_EXCHANGE_READ,
    icon: 'fa fa-earth-europe',
    path: 'exchange/clearing-house',
  };
  static readonly EXCHANGE_CLEARING_HOUSE: PageDescription = {
    label: 'page_title.exchange.clearing-house',
    roles: CCRoles.ROLES_EXCHANGE_READ,
    path: 'exchange/clearing-house',
  };
  static readonly EXCHANGE_EXCHANGE: PageDescription = {
    label: 'page_title.exchange.exchange',
    roles: CCRoles.ROLES_EXCHANGE_READ,
    path: 'exchange/exchange',
  };
  static readonly EXCHANGE_ACCOUNT_TYPE: PageDescription = {
    label: 'page_title.exchange.account-type',
    roles: CCRoles.ROLES_EXCHANGE_READ,
    path: 'exchange/account-type',
  };
  static readonly EXCHANGE_TRADING_ENVIRONMENT: PageDescription = {
    label: 'page_title.exchange.trading-environment',
    roles: CCRoles.ROLES_EXCHANGE_READ,
    path: 'exchange/trading-environment',
  };
  static readonly EXCHANGE_CONTRACT: PageDescription = {
    label: 'page_title.exchange.contract',
    roles: CCRoles.ROLES_EXCHANGE_READ,
    path: 'exchange/contract',
  };
  static readonly EXCHANGE_MATURITY_REJECTION_RULE: PageDescription = {
    label: 'page_title.exchange.reject-rule',
    roles: CCRoles.ROLES_EXCHANGE_READ,
    path: 'exchange/reject-rule',
  };
  static readonly EXCHANGE_OWNER_CODE: PageDescription = {
    label: 'page_title.exchange.owner-code',
    roles: CCRoles.ROLES_EXCHANGE_READ,
    path: 'exchange/owner-code',
  };
  static readonly EXCHANGE_BROKER_CODE: PageDescription = {
    label: 'page_title.exchange.broker-code',
    roles: CCRoles.ROLES_EXCHANGE_READ,
    path: 'exchange/broker-code',
  };
  static readonly URLS: PageDescription[] = [
    CrystalClearFrontUrlExchange.EXCHANGE_CLEARING_HOUSE,
    CrystalClearFrontUrlExchange.EXCHANGE_EXCHANGE,
    CrystalClearFrontUrlExchange.EXCHANGE_ACCOUNT_TYPE,
    CrystalClearFrontUrlExchange.EXCHANGE_TRADING_ENVIRONMENT,
    CrystalClearFrontUrlExchange.EXCHANGE_CONTRACT,
    CrystalClearFrontUrlExchange.EXCHANGE_MATURITY_REJECTION_RULE,
    CrystalClearFrontUrlExchange.EXCHANGE_OWNER_CODE,
    CrystalClearFrontUrlExchange.EXCHANGE_BROKER_CODE,
  ];
}

